export const platformUrl = "https://beta.sekreterare.nu/";
